"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StageItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const stage_item_style_1 = __importDefault(require("./stage.item.style"));
class StageItem extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children } = this.props;
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "data-cy": "atomic-stage-item" }, { children: children }), void 0));
        };
    }
}
exports.StageItem = StageItem;
StageItem.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node
};
StageItem.defaultProps = {
    children: null
};
exports.default = react_jss_1.default(stage_item_style_1.default)(StageItem);
//# sourceMappingURL=stage.item.js.map